// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Icon, Grid, Image, Card, Segment } from 'semantic-ui-react'
import rnicon from '../assets/rnicon.svg'
import expoicon from '../assets/expoicon.svg'
// import codeicon from '../assets/codeicon.png'

export default class MetaData extends Component {
  render () {
    return (
      <div className='mts'>
        <Grid verticalAlign='middle' stackable centered>
          <Grid.Column width='8'>
            <Segment basic textAlign='center'>
              <Image style={{ height: 30 }} src={rnicon} centered />
              <h5>Built with React Native</h5>
            </Segment>
          </Grid.Column>
          <Grid.Column width='8'>
            <Segment basic textAlign='center'>
              <Image style={{ height: 30 }} src={expoicon} centered />
              <h5>Compatible with Expo</h5>
            </Segment>
          </Grid.Column>
        </Grid>
      </div>
    )
  }
}
